import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDmzM1Xz5LScES--T3ofOtOVrJDAWaF59U",
  authDomain: "btop-wellness.firebaseapp.com",
  projectId: "btop-wellness",
  storageBucket: "btop-wellness.firebasestorage.app",
  messagingSenderId: "746244954078",
  appId: "1:746244954078:web:d8ac3dd4cc139cb7346f4f",
  measurementId: "G-TYBY7EPNRB"
};

const app = initializeApp(firebaseConfig);
const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY;
const appCheckDebugToken = process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN;
const isLocalhost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

if (typeof window !== 'undefined' && appCheckDebugToken) {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = appCheckDebugToken;
}

export const appCheck = appCheckSiteKey && (!isLocalhost || appCheckDebugToken)
  ? initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    })
  : null;

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
